/* eslint-disable dot-notation */
import axios, { AxiosInstance } from 'axios';
import cookies from '../../infrastructures/cookies';
import { AUTH_TOKEN_KEY } from '@/hooks/authorization';

type ApiServiceProps = {
  api: AxiosInstance;
  fetcher: (url: string) => Promise<unknown>;
};

export default function ApiService(): ApiServiceProps {
  const token = cookies.get(AUTH_TOKEN_KEY);

  const api = axios.create({
    baseURL: process.env['REACT_APP_PUBLIC_API_URL'],
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  });

  const fetcher = (url: string): Promise<unknown> =>
    api.get(url).then((res) => res.data);

  return { api, fetcher };
}
